module.exports = __webpack_public_path__ + "static/media/ic_tablet.a63fa247.svg";